import { testIsArray, testIsNotNumberIsh } from '../lib/test-and-assert/test-base';

class SerializeHelper {
    /**
     * @param value
     * @param [defaultValue=null]
     */
    static getInteger(value, defaultValue) {
        if (testIsNotNumberIsh(value)) {
            return defaultValue ?? null;
        }

        return parseInt(value);
    }

    /**
     * @param value
     * @param [defaultValue=null]
     */
    static getFloat(value, defaultValue) {
        if (testIsNotNumberIsh(value)) {
            return defaultValue ?? null;
        }

        return parseFloat(value);
    }

    /**
     * @param value
     * @param {Function} objectClassConstructor
     * @param [defaultValue=[]]
     */
    static getArrayOfObject(value, objectClassConstructor, defaultValue) {
        if (!testIsArray(value)) {
            return defaultValue ?? [];
        }

        return Array.from(value, (data) => new objectClassConstructor(data));
    }
}

export { SerializeHelper };
